
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    adminToggleContainer: {
        position: 'relative',
        display: 'inline-block'
    },
    adminToggle: {
        position: 'absolute',
        left: 0,
        bottom: '-60px',
        width: '150px',
        height: '55px',
        padding: '10px',
        backgroundColor: '#FFF',
        border: '1px solid #ccc',
        borderRadius: '3px',
        zIndex: 1050
    },
    badgeContainer: {
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        lineHeight: '20px',
        letterSpacing: '0.4px',
        paddingTop: '0px',
        paddingBottom: '0px',
        color: '#ffffff',
        backgroundColor: '#00c8ff',
        borderRadius: '10px',
        display: 'inline-block',
        height: '20px',
        textAlign: 'center',
        width: '20px'
    },
    buttonWithShadow: {
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        lineHeight: '16px',
        letterSpacing: '0.4px',
        paddingTop: '0px',
        paddingBottom: '0px',
        color: '#484848',
        fontWeight: 700,
        backgroundColor: '#ffffff',
        padding: '8px 16px',
        boxShadow: '0 1px 1px 1px rgba(0, 0, 0, 0.14)',
        borderRadius: '80px',
        border: 'none',
        cursor: 'pointer',
        textTransform: 'uppercase',
        outline: 'none'
    },
    buttonContainer: {
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        lineHeight: 1,
        letterSpacing: '0.4px',
        paddingTop: '0px',
        paddingBottom: '0px',
        color: '#484848',
        fontWeight: 700,
        overflow: 'hidden',
        boxShadow: '0 1px 1px 1px rgba(0, 0, 0, 0.14)',
        borderRadius: '80px',
        backgroundColor: '#ffffff',
        display: 'inline-block'
    },
    button: {
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        lineHeight: '16px',
        letterSpacing: '0.4px',
        paddingTop: '8px',
        paddingBottom: '8px',
        color: '#484848',
        fontWeight: 700,
        textTransform: 'uppercase',
        backgroundColor: 'transparent',
        border: 'none',
        display: 'inline-block',
        verticalAlign: 'middle',
        cursor: 'pointer',
        outline: 'none'
    },
    buttonLeft: {
        paddingLeft: '16px',
        paddingRight: '8px',
        '@media (min-width: 744px) and (max-width: 1127px)': {
            paddingRight: '16px'
        },
        '@media only screen and (min-width : 360px) and (max-width : 736px)': {
            paddingRight: '16px'
        }
    },
    container: {
        height: '48px',
        width: '100%',
        position: 'initial',
        overflowX: 'initial',
        whiteSpace: 'initial'
    },
    dividerOuter: {
        display: 'inline',
        verticalAlign: 'middle'
    },
    divider: {
        display: 'inline',
        height: '100%',
        borderLeft: '1px solid #767676'
    },
    containerTable: {
        display: 'table'
    },
    containerTableChild: {
        display: 'table-cell',
        verticalAlign: 'middle'
    },
    container_withMdSplitMap: {
        display: 'inline-block'
    },
    filterBar: {
        background: '#ffffff',
        height: '65px',
        borderBottom: '0px',
        width: '100%',
        padding: '0px',
        zIndex: 4,
        position: 'relative',
        paddingLeft: '16px',
        paddingTop: '16px'
    },
    filterBarWrapper: {
        height: '65px',
        background: '#ffffff',
        position: 'fixed',
        zIndex: 9,
        width: '66%',
        '@media (min-width: 744px) and (max-width: 1127px)': {
            width: '100%'
        }
    },
    filterBarWrapperRelative: {
        height: '65px',
        position: 'relative',
        width: '66%'
    },
    filtersButtonWrapper: {
        display: 'inline-block',
        '@media (min-width: 744px) and (max-width: 1127px)': {
            display: 'none'
        },
        '@media only screen and (min-width : 360px) and (max-width : 736px)': {
            display: 'none'
        }
    },
    icon: {
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        fontSize: '14px',
        lineHeight: '18px',
        letterSpacing: 'undefined',
        paddingTop: 'undefined',
        paddingBottom: 'undefined',
        color: '#484848'
    },
    outContainer: {
        left: '0px',
        right: '0px',
        bottom: '16px',
        position: 'fixed',
        opacity: 1,
        textAlign: 'center',
        transitionProperty: 'opacity',
        transitionDuration: '250ms',
        transitionTimingFunction: 'ease-out',
        zIndex: 51,
        '@media (min-width: 1128px)': {
            opacity: 0,
            visibility: 'hidden'
        }
    },
    overlay: {
        position: 'fixed',
        height: '100vh',
        top: '65px',
        zIndex: 1,
        background: 'rgba(255, 255, 255, 0.85)'
    },
    overlay_sixtysix: {
        width: '66%',
        '@media (min-width: 744px) and (max-width: 1127px)': {
            width: '100%'
        }
    },
    overlay_fullwidth: {
        width: '100%'
    },
    wrapper: {
        display: 'inline-block',
        verticalAlign: 'middle'
    },
    filterBarSection: {
        '@media (max-width: 736px)': {
            display: 'none'
        },
        '@media (min-width: 737px)': {
            display: 'block'
        }
    },
    screenLgButton: {
        '@media (max-width: 1127px)': {
            display: 'none'
        },
        '@media (min-width: 744px)': {
            display: 'block'
        }
    },
    screenSmButton: {
        '@media (min-width: 1128px)': {
            display: 'none'
        },
        '@media (max-width: 1127px)': {
            display: 'block'
        }
    },
    select: {
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingRight: '2em',
        appearance: 'none',
        outline: 'none',
        background: 'white',
        textIndent: '0.01px',
        fontSize: '14px'
    },
    selectContainer: {
        position: 'relative',
        display: 'block',
        width: '100%',
        verticalAlign: 'bottom',
        ':before': {
            content: '"\\25bc"',
            position: 'absolute',
            pointerEvents: 'none',
            color: '#767676',
            top: 0,
            bottom: '1px',
            paddingTop: '0.7em',
            lineHeight: 1,
            right: 0,
            width: '2em',
            textAlign: 'center',
            transform: 'scale(0.84, 0.42)',
            filter: 'progid: DXImageTransform.Microsoft.Matrix(M11=.84, M12=0, M21=0, M22=.42, SizingMethod="auto expand")'
        }
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/styles.js